import { ConsentTextId } from '../../interfaces/consents.interface';

/**
 * Defines how a consent should be handled in the join form
 *
 * SHOW_UNCHECKED - Displayed to user, unchecked by default (opt-in)
 * SHOW_CHECKED - Displayed to user, checked by default (opt-out to decline)
 * AUTO_TRUE - Not displayed, automatically sent as true (accepted)
 * AUTO_FALSE - Not displayed, automatically sent as false (declined)
 * IGNORE - Not displayed, not sent to backend at all (ignored)
 */
export enum ConsentDisplayBehavior {
  SHOW_UNCHECKED = 'show_unchecked',
  SHOW_CHECKED = 'show_checked',
  AUTO_TRUE = 'auto_true',
  AUTO_FALSE = 'auto_false',
  IGNORE = 'ignore',
}

/**
 * Configuration for Finnair Plus join form marketing consents
 * Maps each consent ID to its display behavior
 */
export const FPLUS_JOIN_CONSENT_CONFIG: Partial<Record<ConsentTextId, ConsentDisplayBehavior>> = {
  [ConsentTextId.FLIGHT_OFFERS]: ConsentDisplayBehavior.SHOW_CHECKED,

  [ConsentTextId.MEMBER_OFFERS]: ConsentDisplayBehavior.SHOW_UNCHECKED,
  [ConsentTextId.MEMBER_OFFERS_TRAVEL]: ConsentDisplayBehavior.SHOW_UNCHECKED,
  [ConsentTextId.MEMBER_OFFERS_FINANCIAL]: ConsentDisplayBehavior.SHOW_UNCHECKED,
  [ConsentTextId.MEMBER_OFFERS_RETAIL]: ConsentDisplayBehavior.SHOW_UNCHECKED,
  [ConsentTextId.MEMBER_OFFERS_EVENT]: ConsentDisplayBehavior.SHOW_UNCHECKED,

  [ConsentTextId.BOOKING_COMMUNICATION]: ConsentDisplayBehavior.IGNORE,
  [ConsentTextId.TARGETED_ADVERTISING]: ConsentDisplayBehavior.AUTO_TRUE,
  [ConsentTextId.FPLUS_COMMUNICATION]: ConsentDisplayBehavior.SHOW_CHECKED,
  [ConsentTextId.PROFILING]: ConsentDisplayBehavior.AUTO_TRUE,
};

/**
 * Order in which to display consents in the join form
 * Only affects SHOW_* consents; AUTO_* consents are not displayed
 */
export const FPLUS_JOIN_CONSENT_DISPLAY_ORDER: ConsentTextId[] = [
  ConsentTextId.FPLUS_COMMUNICATION,
  ConsentTextId.FLIGHT_OFFERS,
  ConsentTextId.MEMBER_OFFERS,
  ConsentTextId.MEMBER_OFFERS_FINANCIAL,
  ConsentTextId.MEMBER_OFFERS_TRAVEL,
  ConsentTextId.MEMBER_OFFERS_RETAIL,
  ConsentTextId.MEMBER_OFFERS_EVENT,
];

export const MEMBER_OFFERS_CONSENTS: ConsentTextId[] = [
  ConsentTextId.MEMBER_OFFERS_FINANCIAL,
  ConsentTextId.MEMBER_OFFERS_TRAVEL,
  ConsentTextId.MEMBER_OFFERS_RETAIL,
  ConsentTextId.MEMBER_OFFERS_EVENT,
];
